import { Database } from "lucide-react";

export function SqlIcon({ className }: { className?: string }) {
  return <Database className={className} strokeWidth={1.5} />;
}
